import { designatePAA, submitTINRequest } from './requests';

export const designatePAASaga = async ({ action }) => {
  return designatePAA(action.payload);
};

export const submitTINRequestSaga = async ({ action }) => {
  return submitTINRequest(action.payload);
};
